import PropTypes from 'prop-types'
import { FaEdit, FaTrash } from "react-icons/fa";
import Button, { BUTTON_TYPES } from '../../Button';

/**
 * Copy Link Input component
 * 
 * @param {object} props
 * @param {string} props.id - component ID
 * @param {string} props.placeholder - placeholder text for input
 * @param {string} props.label - label text that appears above the input
 * @param {boolean} props.required - true if input is required, false otherwise
 * @param {number} props.charLimit - maximum number of characters that can be input
 * @param {string} props.value - the current value held in the input (used with useState)
 * @param {Function} props.setValue - function for setting some state to the current input value
 */

const AdminSettingsItem = ({ id, placeholder, label, required, charLimit, value, setValue , openModal}) => {


    return (
        <div className="remove-requirement-center">
            {label && (
                <label className="input-label" htmlFor={id}>
                    {required ? `${label} *` : label}
                </label>
            )}
            <div className="inner">
                <input
                    type="text"
                    id={id}
                    name={id}
                    placeholder={placeholder}
                    maxLength={charLimit}
                    required={required}
                    value={value}
                    readOnly
                    onChange={setValue}
                    style={{ flex: 1, padding: '0.5rem', textAlign: 'left', width: '22rem' , margin: '0.5rem'}}
                />
                <Button
                    id="edit-item-button"
                    type={BUTTON_TYPES.outline}
                    buttonText={<FaEdit />}
                    action={() => openModal('edit', id)}
                    style={{marginRight: '0.25em'}}
                />
                <Button
                    id="delete-item-button"
                    type={BUTTON_TYPES.outline}
                    buttonText={<FaTrash />}
                    action={() => openModal('delete', id)}
                />
            </div>
        </div>
    );
};

AdminSettingsItem.propTypes = {
    id: PropTypes.number.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    charLimit: PropTypes.number,
    value: PropTypes.string,
    setValue: PropTypes.func,
    openModal: PropTypes.func,
};

export default AdminSettingsItem;
